export const padZero = (num: number) => num.toString().padStart(2, '0')
